import { useOnboardingState } from "@/modules/onboarding/engine/onboarding.hooks";
import { Navigate, Outlet } from "react-router-dom";

export const OnboardingRoute = () => {
	const { stepsQ } = useOnboardingState();
	if (stepsQ.isLoading) return null;

	const isOnboardingFinished = stepsQ.data?.Steps.includes('Finished') ?? false;
	if (isOnboardingFinished) return <Outlet />;

	return <Navigate to="/" replace />;
};
